export default {
  clanPedigreeDetails: null,
  clanPedigreeDetailsLoading: false,
};
